<template>
  <div class="collapse navbar-collapse stroke show d-lg-none" id="navbarNav">
    <transition>
      <ul id="HeaderUL" class="navbar-nav ulphone" v-if="showMenu">
        <li id="HeaderAboutLink" class="nav-item">
          <router-link to="/home" @click="toggleMenu" class="nav-link"
            >Über uns</router-link
          >
        </li>
        <li id="HeaderSkillsLink" class="nav-item btn">
          <router-link to="/technologien" @click="toggleMenu" class="nav-link"
            >Unsere Skills</router-link
          >
        </li>
        <li id="HeaderSkillsLink" class="nav-item btn">
          <router-link to="/partner" @click="toggleMenu" class="nav-link"
            >Unsere Partner</router-link
          >
        </li>


       <li id="HeaderKontaktLink" class="nav-item btn">
        <a
          class="nav-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://games.lumabit.de/officetour/"
          >Office-Tour</a
          >
        </li>


        <li id="HeaderJobLink" class="nav-item">
          <router-link to="/jobs" @click="toggleMenu" class="nav-link"
            >Jobs</router-link
          >
        </li>
        <li id="HeaderKontaktLink" class="nav-item">
          <router-link to="/contact" @click="toggleMenu" class="nav-link"
            >Kontakt</router-link
          >
        </li>
        
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    showMenu: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleMenu() {
      this.$emit("update:showMenu", !this.showMenu);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
ul {
  align-items: center;
}

li {
  padding: 14px 0px;
}

.ulphone {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 90px;
  z-index: 2;
  padding-top: 20px;
  height: 100%;
  background-image: linear-gradient(to right, #6f42c1, #e83e8c);
  display: flex;
  flex-direction: column;
  /* add this line for smooth animation */
}

.v-enter-from {
  height: 0%;
  opacity: 0;
}

.v-enter-active {
  transition: all 0.2s ease-out;
}

.v-enter-to {
  height: 100%;
  opacity: 1;
}

.v-leave-from {
  height: 100%;
  opacity: 1;
}

.v-leave-active {
  transition: all 0.4s ease-out;
  height: 0%;
}

.v-leave-to {
  opacity: 0;
}
</style>
